module.exports = __webpack_public_path__ + "static/media/default.5a8cd5bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/files/default.png
// module id = 802
// module chunks = 2